<template>
  <Taptop />
  <div class="page-wrapper" :class="layoutState.config.settings.sidebar_type" id="pageWrapper">
    <div class="page-header" :class="{ close_icon: layoutState.closeSidebar }">
      <Header />
    </div>
    <div class="page-body-wrapper">
      <div class="sidebar-wrapper" :data-layout="layoutState.config.settings.icon" :class="{ close_icon: layoutState.closeSidebar }">
        <Sidebar />
      </div>

      <div class="page-body">
        <Breadcrumbs />
        <router-view v-slot="{ Component }">
          <transition name="slide-fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
      <Footer />
    </div>
  </div>
  <Loader />
</template>
<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue';

import { useWindowSize } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';

import { useLayout } from '@/stores/layout';

// Switched from defineAsyncComponent to synchronous imports: lazy-loading the
// six children meant Vue planted six comment-placeholder anchors next to each
// other, and when any of them resolved its setup before another, Vue 3's
// patcher could lose track of nextSibling and crash with
// "Cannot read 'nextSibling' of null". The layout shell is loaded eagerly
// for every protected page anyway, so the lazy-load buys us nothing.
import Header from '@/components/layout/header/Header.vue';
import Sidebar from '@/components/layout/sidebar/Sidebar.vue';
import Footer from '@/components/layout/footer/Footer.vue';
import Breadcrumbs from '@/components/layout/breadCrumb/Breadcrumbs.vue';
import Taptop from '@/components/layout/taptop/Taptop.vue';
import Loader from '@/components/layout/Loader.vue';

const route = useRoute();
const { width } = useWindowSize();
const layoutStore = useLayout();
const { layoutState } = storeToRefs(layoutStore);
const { applyLayout } = layoutStore;

const layout = ref<string>('');

onMounted(() => {
  if (route.query.layout) {
    layout.value = route.query.layout.toString();
  } else {
    layout.value = localStorage.getItem('layout') || 'seoul';
  }
  localStorage.setItem('layout', layout.value);
  layoutState.value.config.settings.layout = layout.value;
  applyLayout(layout.value);
  // handleLayout is called by the width watcher with immediate: true
});

watch(
  width,
  newWidth => {
    handleLayout(newWidth);
  },
  { immediate: true },
);

// Page transition animation handled by <transition name="slide-fade">

function handleLayout(width: number) {
  layoutState.value.closeSidebar = width < 1200;

  if (width < 1200) {
    layoutState.value.config.settings.sidebar_type = 'compact-wrapper';
  } else {
    if (layout.value) {
      applyLayout(layout.value);
    }
  }
}
</script>
